import { PromptRequest, PromptTypeKey } from "../../../types/promptTypes";
import FieldContainer from "./FieldContainer";
import InputField from "../../dynamic/InputField";
import { usePromptStore } from "../../../store/promptStore";
type PasswordFieldProps = {
  index: number;
  onEnter?: () => void;
};

const PasswordField = (props: PasswordFieldProps) => {
  const { index, onEnter } = props;
  const prompts = usePromptStore((state) => state.prompts);
  const field = prompts[index] as PromptRequest<PromptTypeKey.PASSWORD>;
  const setPromptValue = usePromptStore((state) => state.setPromptValue);
  const promptValue = usePromptStore((state) => state.promptValues[index]);

  return (
    <div>
      <FieldContainer field={field}>
        <InputField
          type="password"
          label={field.label}
          value={promptValue}
          onChange={(value) => setPromptValue(index, value)}
          onEnter={onEnter}
          autoFocus={index === 0}
        />
      </FieldContainer>
    </div>
  );
};

export default PasswordField;
